import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { UserService } from 'app/core/user/user.service';
import { StoreService } from './ngrx/store.service';
import { selectConnectedUser } from './ngrx/selectors/user.selectors';
import { Store } from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private readonly _messagesService: MessagesService,
        private readonly _navigationService: NavigationService,
        private readonly _notificationsService: NotificationsService,
        private readonly _quickChatService: QuickChatService,
        private readonly _shortcutsService: ShortcutsService,
        private readonly _userService: UserService,
        private readonly storeService:StoreService,
        private store: Store
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return this.store.select(selectConnectedUser).pipe(
          switchMap((user) => {
              if (user) {
                  return forkJoin([
                      this._navigationService.get(),
                      this._messagesService.getAll(),
                      this._notificationsService.getAll(),
                      this._quickChatService.getChats(),
                      this._shortcutsService.getAll(),
                      this._userService.fetchUserByEmail(user.email),
                  ]);
              }
              // Handle the case where no user is found (optional)
              return of([]); // Return an empty array or appropriate default value
          })
        );
    }
}
